{
    "schemaNameConfig": {
      "cssPropertySchemas": {
        "useSchemasFromDefinitions": true,
        "useAbsoluteUrn": true
      }
    },
    "variables": {
        "commonSchemas": {
            "UnitSize": {
                "variableName": "UnitSizeVar",
                "variableValueName": "UnitSizeValue"
            },
            "NumberThatCanConnectToAVariable": {
                "variableName": "NumberVar",
                "variableValueName": "NumberValue"
            }
        },
        "layout": {
            "ItemsAlignment": {
                "variableName": "ItemsAlignmentVar",
                "variableValueName": "ItemsAlignmentValue"
            },
            "JustifyContent": {
                "variableName": "JustifyContentVar",
                "variableValueName": "JustifyContentValue"
            },
            "PositionType": {
                "variableName": "PositionTypeVar",
                "variableValueName": "PositionTypeValue"
            },
            "LayoutSize": {
                "variableName": "LayoutSizeVar",
                "variableValueName": "LayoutSizeValue"
            },
            "Height": {
                "variableName": "HeightVar",
                "variableValueName": "HeightValue"
            },
            "KeywordLength": {
                "variableName": "KeywordLengthVar",
                "variableValueName": "KeywordLengthValue"
            }
        },
        "cssPropertySchemas": {
            "CSS.Number": {
              "variableName": "NumVar",
              "variableValueName": "NumValue"
            },
            "CSS.Length": {
              "variableName": "LengthVar",
              "variableValueName": "LengthValue"
            },
            "CSS.Angle": {
              "variableName": "AngleVar",
              "variableValueName": "AngleValue"
            },
            "CSS.Color": {
              "variableName": "ColorVar",
              "variableValueName": "ColorValue"
            },
            "CSS.Percentage": {
              "variableName": "PercentageVar",
              "variableValueName": "PercentageValue"
            },
            "CSS.BorderTopStyle": {
              "variableName": "BorderEdgeStyleVar",
              "variableValueName": "BorderEdgeStyleValue"
            },
            "CSS.BorderTopWidth": {
              "variableName": "BorderEdgeWidthVar",
              "variableValueName": "BorderEdgeWidthValue"
            },
            "CSS.BorderWidth": {
              "variableName": "BorderWidthVar",
              "variableValueName": "BorderWidthValue"
            },
            "CSS.BorderStyle": {
              "variableName": "BorderStyleVar",
              "variableValueName": "BorderStyleValue"
            },
            "CSS.BorderColor": {
              "variableName": "BorderColorVar",
              "variableValueName": "BorderColorValue"
            },
            "CSS.Border": {
              "variableName": "BorderVar",
              "variableValueName": "BorderValue"
            },
            "CSS.BorderTopLeftRadius": {
              "variableName": "BorderCornerRadiusVar",
              "variableValueName": "BorderCornerRadiusValue"
            },
            "CSS.BorderRadius": {
              "variableName": "BorderRadiusVar",
              "variableValueName": "BorderRadiusValue"
            },
            "CSS.Font": {
              "variableName": "FontVar",
              "variableValueName": "FontValue"
            },
            "CSS.FontSize": {
              "variableName": "FontSizeVar",
              "variableValueName": "FontSizeValue"
            },
            "CSS.FontStretch": {
              "variableName": "FontStretchVar",
              "variableValueName": "FontStretchValue"
            },
            "CSS.FontStyle": {
              "variableName": "FontStyleVar",
              "variableValueName": "FontStyleValue"
            },
            "CSS.FontVariant": {
              "variableName": "FontVariantVar",
              "variableValueName": "FontVariantValue"
            },
            "CSS.FontWeight": {
              "variableName": "FontWeightVar",
              "variableValueName": "FontWeightValue"
            },
            "CSS.FontFamily": {
              "variableName": "FontFamilyVar",
              "variableValueName": "FontFamilyValue"
            },
            "CSS.LineHeight": {
              "variableName": "LineHeightVar",
              "variableValueName": "LineHeightValue"
            },
            "CSS.LetterSpacing": {
              "variableName": "LetterSpacingVar",
              "variableValueName": "LetterSpacingValue"
            },
            "CSS.TextAlign": {
              "variableName": "TextAlignVar",
              "variableValueName": "TextAlignValue"
            },
            "CSS.TextTransform": {
              "variableName": "TextTransformVar",
              "variableValueName": "TextTransformValue"
            },
            "CSS.TextShadow": {
              "variableName": "TextShadowVar",
              "variableValueName": "TextShadowValue"
            },
            "CSS.TextDecoration": {
              "variableName": "TextDecorationVar",
              "variableValueName": "TextDecorationValue"
            },
            "CSS.TextDecorationLine": {
              "variableName": "TextDecorationLineVar",
              "variableValueName": "TextDecorationLineValue"
            },
            "CSS.TextDecorationStyle": {
              "variableName": "TextDecorationStyleVar",
              "variableValueName": "TextDecorationStyleValue"
            },
            "CSS.TextDecorationThickness": {
              "variableName": "TextDecorationThicknessVar",
              "variableValueName": "TextDecorationThicknessValue"
            },
            "CSS.Padding": {
              "variableName": "PaddingVar",
              "variableValueName": "PaddingValue"
            },
            "CSS.PaddingTop": {
              "variableName": "PaddingEdgeVar",
              "variableValueName": "PaddingEdgeValue"
            },
            "CSS.Margin": {
              "variableName": "MarginVar",
              "variableValueName": "MarginValue"
            },
            "CSS.MarginTop": {
              "variableName": "MarginEdgeVar",
              "variableValueName": "MarginEdgeValue"
            },
            "CSS.BoxShadow": {
              "variableName": "BoxShadowVar",
              "variableValueName": "BoxShadowValue"
            },
            "CSS.Opacity": {
              "variableName": "OpacityVar",
              "variableValueName": "OpacityValue"
            },
            "CSS.JustifyContent": {
              "variableName": "CssJustifyContentVar",
              "variableValueName": "CssJustifyContentValue"
            },
            "CSS.Background": {
              "variableName": "BackgroundVar",
              "variableValueName": "BackgroundValue"
            },
            "CSS.WritingMode": {
              "variableName": "WritingModeVar",
              "variableValueName": "WritingModeValue"
            },
            "CSS.Display": {
              "variableName": "DisplayVar",
              "variableValueName": "DisplayValue"
            },
            "CSS.Filter": {
              "variableName": "FilterVar",
              "variableValueName": "FilterValue"
            },
            "CSS.Gap": {
              "variableName": "GapVar",
              "variableValueName": "GapValue"
            }
      }

    },
    "schemasThatUseVariables": {
        "layout": {
            "GridTrackSize": "UnitSize"
        }
    }
}
